var _circle, _mask, _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmailCircle = function SvgEmailCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#000"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "email_circle_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 14,
    height: 10,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 14,
    height: 10,
    rx: 1,
    stroke: "#fff",
    strokeWidth: 2.4,
    mask: "url(#email_circle_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.2,
    d: "m5.951 7.885 6.442 5.594M18.05 7.885l-6.443 5.594M5.532 16.078l5.12-4.049M18.468 16.078l-5.12-4.049"
  })));
};

export default SvgEmailCircle;